<template>
  <Transition
    enter-active-class="transition ease-out duration-300"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="showBanner"
      class="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-gray-200 shadow-lg"
    >
      <div class="max-w-6xl mx-auto">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <!-- Text -->
          <div class="flex-1">
            <p class="text-sm text-gray-700">
              Utilizamos cookies para mejorar tu experiencia, analizar el uso del sitio y personalizar contenido.
              Puedes aceptar todas las cookies o configurar tus preferencias.
              <router-link to="/privacidad" class="text-brand-primary hover:underline">
                Más información
              </router-link>
            </p>
          </div>

          <!-- Buttons -->
          <div class="flex flex-col sm:flex-row gap-2 sm:gap-3">
            <button
              @click="handleReject"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Solo necesarias
            </button>
            <button
              @click="showSettings = true"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Configurar
            </button>
            <button
              @click="handleAccept"
              class="px-4 py-2 text-sm font-medium text-white bg-brand-primary rounded-lg hover:bg-brand-primary/90 transition-colors"
            >
              Aceptar todas
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>

  <!-- Settings Modal -->
  <Teleport to="body">
    <Transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="showSettings"
        class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
        @click.self="showSettings = false"
      >
        <div class="bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto">
          <!-- Header -->
          <div class="p-6 border-b border-gray-100">
            <h2 class="text-xl font-bold text-gray-900">Configuración de Cookies</h2>
            <p class="mt-1 text-sm text-gray-500">
              Elige qué tipos de cookies deseas permitir
            </p>
          </div>

          <!-- Cookie Categories -->
          <div class="p-6 space-y-4">
            <!-- Necessary -->
            <div class="p-4 bg-gray-50 rounded-xl">
              <div class="flex items-center justify-between">
                <div>
                  <h3 class="font-medium text-gray-900">Cookies necesarias</h3>
                  <p class="text-sm text-gray-500 mt-1">
                    Esenciales para el funcionamiento del sitio. Incluyen autenticación y seguridad.
                  </p>
                </div>
                <span class="text-xs font-medium text-gray-400 bg-gray-200 px-2 py-1 rounded">
                  Siempre activas
                </span>
              </div>
            </div>

            <!-- Analytics -->
            <div class="p-4 bg-gray-50 rounded-xl">
              <div class="flex items-center justify-between">
                <div class="flex-1 mr-4">
                  <h3 class="font-medium text-gray-900">Cookies de análisis</h3>
                  <p class="text-sm text-gray-500 mt-1">
                    Nos ayudan a entender cómo usas el sitio para mejorarlo. Incluyen estadísticas de uso y grabación de sesiones.
                  </p>
                </div>
                <label class="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    v-model="settings.analytics"
                    class="sr-only peer"
                  />
                  <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-brand-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-primary"></div>
                </label>
              </div>
            </div>

            <!-- Marketing (future) -->
            <div class="p-4 bg-gray-50 rounded-xl opacity-50">
              <div class="flex items-center justify-between">
                <div class="flex-1 mr-4">
                  <h3 class="font-medium text-gray-900">Cookies de marketing</h3>
                  <p class="text-sm text-gray-500 mt-1">
                    Permiten mostrar anuncios relevantes. Actualmente no utilizamos este tipo de cookies.
                  </p>
                </div>
                <label class="relative inline-flex items-center cursor-not-allowed">
                  <input
                    type="checkbox"
                    v-model="settings.marketing"
                    disabled
                    class="sr-only peer"
                  />
                  <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-brand-primary"></div>
                </label>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="p-6 border-t border-gray-100 flex justify-end gap-3">
            <button
              @click="showSettings = false"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Cancelar
            </button>
            <button
              @click="handleSaveSettings"
              class="px-4 py-2 text-sm font-medium text-white bg-brand-primary rounded-lg hover:bg-brand-primary/90 transition-colors"
            >
              Guardar preferencias
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCookieConsent } from '@/composables/useCookieConsent'

const { hasUserDecided, acceptAll, rejectAll, setConsent } = useCookieConsent()

const showBanner = ref(false)
const showSettings = ref(false)
const settings = ref({
  analytics: false,
  marketing: false
})

onMounted(() => {
  // Show banner only if user hasn't decided yet
  showBanner.value = !hasUserDecided()
})

function handleAccept() {
  acceptAll()
  showBanner.value = false
  // Reload to initialize analytics
  window.location.reload()
}

function handleReject() {
  rejectAll()
  showBanner.value = false
}

function handleSaveSettings() {
  setConsent(settings.value)
  showSettings.value = false
  showBanner.value = false
  // Reload if analytics were enabled
  if (settings.value.analytics) {
    window.location.reload()
  }
}
</script>
